const uuidv4 = require("uuid/v4");
import { mapState, mapMutations, mapActions } from "vuex";

export const products = {
  computed: {
    ...mapState({
      minerva: state => state.minerva.minerva,
      moldedSeat: state => state.moldedSeat.moldedSeat,
      otn: state => state.otn.otn,
      lift: state => state.lift.lift,
      retouchingRepair: state => state.retouchingRepair.retouchingRepair,
      seat: state => state.seat.seat,
      positioningSeat: state => state.positioningSeat.positioningSeat,
      upperLimb: state => state.upperLimb.upperLimb,
      corset: state => state.corset.corset,
      lowerLimb: state => state.lowerLimb.lowerLimb
    })
  },
  methods: {
    ...mapMutations({
      setSnackbar: "setSnackbar",

      setMinerva: "minerva/SET_MINERVA",
      cleanMinerva: "minerva/RESET_MINERVA",
      setMoldedSeat: "moldedSeat/SET_MOLDED_SEAT",
      cleanMoldedSeat: "moldedSeat/RESET_MOLDED_SEAT",
      setOtn: "otn/SET_OTN",
      cleanOtn: "otn/RESET_OTN",
      setLift: "lift/SET_LIFT",
      cleanLift: "lift/RESET_LIFT",
      setRetouchingRepair: "retouchingRepair/setRetouchingRepair",
      cleanRetouchingRepair: "retouchingRepair/cleanRetouchingRepair",
      setSeat: "seat/SET_SEAT",
      cleanSeat: "seat/RESET_SEAT",
      setPositioningSeat: "positioningSeat/SET_POSITIONING_SEAT",
      cleanPositioningSeat: "positioningSeat/RESET_POSITIONING_SEAT",
      setUpperLimb: "upperLimb/SET_UPPER_LIMB",
      cleanUpperLimb: "upperLimb/RESET_UPPER_LIMB",
      setCorset: "corset/SET_CORSET",
      cleanCorset: "corset/RESET_CORSET",
      setLowerLimb: "lowerLimb/SET_LOWER_LIMB",
      cleanLowerLimb: "lowerLimb/RESET_LOWER_LIMB"
    }),

    ...mapActions({
      getLoggedInUser: "auth/getLoggedInUser",
      getLocalProject: "projects/getLocalProject"
    }),

    // Returns object literal
    products() {
      return {
        NECK_BRACE: {
          name: "Minerve",
          state: this.minerva,
          reset: this.cleanMinerva,
          set: this.setMinerva,
          create: this.createMinerva,
          routeName: "NeckBraceProduct",
          table: this.$db.minerva
        },
        MOLDED_SEAT: {
          name: "Siège moulé",
          state: this.moldedSeat,
          reset: this.cleanMoldedSeat,
          set: this.setMoldedSeat,
          create: this.createMoldedSeat,
          routeName: "MoldedSeatProduct",
          table: this.$db.molded_seat
        },
        OTN: {
          name: "OTN",
          state: this.otn,
          reset: this.cleanOtn,
          set: this.setOtn,
          create: this.createOtn,
          routeName: "OtnProduct",
          table: this.$db.otn
        },
        LIFT: {
          name: "Verticalisateur",
          state: this.lift,
          reset: this.cleanLift,
          set: this.setLift,
          create: this.createLift,
          routeName: "LiftProduct",
          table: this.$db.lift
        },
        RETOUCHING_REPAIR: {
          name: "Retouching/Réparation",
          state: this.retouchingRepair,
          reset: this.cleanRetouchingRepair,
          set: this.setRetouchingRepair,
          create: this.createRetouchingRepair,
          routeName: "RetouchingRepairProduct",
          table: this.$db.retouching_repair
        },
        SEAT: {
          name: "Selle",
          state: this.seat,
          reset: this.cleanSeat,
          set: this.setSeat,
          create: this.createSeat,
          routeName: "SeatProduct",
          table: this.$db.seat
        },
        POSITIONING_SEAT: {
          name: "Selle de positionnement",
          state: this.positioningSeat,
          reset: this.cleanPositioningSeat,
          set: this.setPositioningSeat,
          create: this.createPositioningSeat,
          routeName: "PositioningSeatProduct",
          table: this.$db.positioning_seat
        },
        UPPER_LIMB_ORTHOSIS: {
          name: "Orthèse M sup",
          state: this.upperLimb,
          reset: this.cleanUpperLimb,
          set: this.setUpperLimb,
          create: this.createUpperLimb,
          routeName: "UpperLimbProduct",
          table: this.$db.upper_limb
        },
        LOWER_LIMB_ORTHOSIS: {
          name: "Orthèse M inf",
          state: this.lowerLimb,
          reset: this.cleanLowerLimb,
          set: this.setLowerLimb,
          create: this.createLowerLimb,
          routeName: "LowerLimbProduct",
          table: this.$db.lower_limb
        },
        CORSET: {
          name: "Corset",
          state: this.corset,
          reset: this.cleanCorset,
          set: this.setCorset,
          create: this.createCorset,
          routeName: "CorsetProduct",
          table: this.$db.corset
        }
      };
    },

    // Creates product based on project product model
    async createProduct(project) {
      try {
        const products = this.products();

        // Resets product in store
        products[project.product_model].reset();

        // Gets product from store
        const product = products[project.product_model].state;

        // Gets connected user info
        const user = await this.getLoggedInUser();

        // Add user_id property to product object
        product.user_id = user.id;

        // Creates product
        const product_uuid = await products[project.product_model].create(
          project,
          product
        );

        // Updates project
        project.product_uuid = product_uuid;
        await this.$db.projects.put(project);
      } catch (error) {
        console.log("Synchronization.js Method: createProduct: ", error);
      }
    },

    // Go to product page
    goToProductPage(project) {
      const routeName = this.products()[project.product_model].routeName;

      this.$router.push({
        name: routeName,
        params: { projectUuid: project.uuid }
      });
    },

    // Save product in IndexedDB
    async saveProduct(localProduct) {
      // Check validation
      if (this.$refs.form && !this.$refs.form.validate()) {
        console.log(this.$refs.form);

        this.setSnackbar({
          show: true,
          color: "error",
          text: "Vérifier le formulaire"
        });
        return;
      }

      // Gets products object literal
      const products = this.products();

      try {
        // Gets project from IndexedDB
        const projectUuid = this.$route.params.projectUuid;
        const project = await this.getLocalProject(projectUuid);

        // Sets some props
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;

        let currentProductVersion = project.server_version;
        if (project.local_version) {
          currentProductVersion = project.local_version;
        }

        await products[project.product_model].create(project, localProduct);

        // Delete old local version
        if (currentProductVersion) {
          await products[project.product_model].table.delete(
            currentProductVersion
          );
        }

        // Update product uuid in project
        console.log(products[project.product_model].state.uuid);

        await this.$db.projects.update(project.uuid, {
          local_version: products[project.product_model].state.uuid,
          product_uuid: products[project.product_model].state.uuid
        });

        // Return to project page id successfull
        this.$router.push({
          name: "ProjectPage",
          params: { projectUuid: this.$route.params.projectUuid }
        });
      } catch (error) {
        console.error(error);
      }
    },

    // Create minerve
    async createMinerva(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setMinerva(localProduct);

        return await this.$db.minerva.add(this.minerva);
      } catch (error) {
        console.error(error);
      }
    },

    // Create molded seat
    async createMoldedSeat(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setMoldedSeat(localProduct);

        return await this.$db.molded_seat.add(this.moldedSeat);
      } catch (error) {
        console.error(error);
      }
    },

    // Create otn
    async createOtn(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setOtn(localProduct);

        return await this.$db.otn.add(this.otn);
      } catch (error) {
        console.error(error);
      }
    },

    // Create lift
    async createLift(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setLift(localProduct);

        return await this.$db.lift.add(this.lift);
      } catch (error) {
        console.error(error);
      }
    },

    // Create retouching repair
    async createRetouchingRepair(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setRetouchingRepair(localProduct);

        return await this.$db.retouching_repair.add(this.retouchingRepair);
      } catch (error) {
        console.error(error);
      }
    },

    // Create seat
    async createSeat(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setSeat(localProduct);

        return await this.$db.seat.add(this.seat);
      } catch (error) {
        console.error(error);
      }
    },

    // Create positioning seat
    async createPositioningSeat(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setPositioningSeat(localProduct);

        return await this.$db.positioning_seat.add(this.positioningSeat);
      } catch (error) {
        console.error(error);
      }
    },

    // Create upper limb
    async createUpperLimb(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setUpperLimb(localProduct);

        return await this.$db.upper_limb.add(this.upperLimb);
      } catch (error) {
        console.error(error);
      }
    },

    // Create lower limb
    async createLowerLimb(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setLowerLimb(localProduct);

        return await this.$db.lower_limb.add(this.lowerLimb);
      } catch (error) {
        console.error(error);
      }
    },

    // Create corset
    async createCorset(project, localProduct) {
      try {
        localProduct.uuid = uuidv4();
        localProduct.projects_uuid = project.uuid;
        localProduct.sync = 0;
        this.setCorset(localProduct);

        return await this.$db.corset.add(this.corset);
      } catch (error) {
        console.error(error);
      }
    },

    // Return model name
    getProductName(model) {
      return this.products()[model].name;
    }
  }
};
